import * as React from 'react'
import Dialog, { DialogProps } from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import { PropTypes } from '@mui/material'
import Image from 'next/image'
import { resolveImageUrl } from '@/utils/constants'
import MCButton from './Buttons/MobicomButton'
interface Prop {
  open?: boolean
  onClose: () => void
  onConfirm: () => void
  confirmText?: string
  confirmColor?: PropTypes.Color
  cancelText?: string
  cancelColor?: PropTypes.Color
  loading?: boolean
  children?: React.ReactNode
  size?: DialogProps['maxWidth']
  fullWidth?: boolean
  paperClassName?: string
  hideIcon?: boolean
  showDivider?: boolean
  fullWidthButton?: boolean
  confirmButtonClassName?: string
}

const AlertDialog: React.FunctionComponent<Prop> = (props) => {
  return (
    <Dialog
      fullWidth={props.fullWidth ?? true}
      maxWidth={props.size ?? 'sm'}
      open={props.open ?? false}
      onClose={props.onClose}
      aria-labelledby='confirm-dialog-title'
      PaperProps={props.paperClassName !== undefined ? { className: props.paperClassName } : undefined}
    >
      <div className='p-5 flex justify-center flex-col items-center'>
        <DialogContent className='flex flex-col items-center text-center text-sm w-full'>
          {props.hideIcon !== true && (
            <Image width={32} height={32} draggable={false} src={resolveImageUrl('/uploads/icons/alert.svg')} alt='!' className='mb-4' />
          )}
          {props.children}
        </DialogContent>
        {props.showDivider === true && <hr className='w-full border-t border-textHigh my-3' />}
        <DialogActions className={props.fullWidthButton === true ? 'w-full' : undefined}>
          <div className={props.fullWidthButton === true ? 'w-full' : 'flex justify-center'}>
            <MCButton fullwidth={props.fullWidthButton} onClick={props.onConfirm} disabled={props.loading} classNames={props.confirmButtonClassName}>{props.confirmText}</MCButton>
          </div>
        </DialogActions>
      </div>

    </Dialog>
  )
}
export default AlertDialog
